var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732695514009,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7215,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.345455 958.836364c-174.545455 0-335.127273-102.4-407.272728-262.981819l44.218182-18.618181c65.163636 141.963636 207.127273 235.054545 365.381818 235.054545C728.436364 912.290909 907.636364 733.090909 907.636364 512S728.436364 111.709091 507.345455 111.709091c-148.945455 0-286.254545 81.454545-356.072728 216.436364l-41.890909-20.945455C188.509091 155.927273 339.781818 65.163636 507.345455 65.163636 754.036364 65.163636 954.181818 265.309091 954.181818 512s-200.145455 446.836364-446.836363 446.836364z",
    fill: "#1296db",
    "p-id": 7216
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.818182 751.709091L93.090909 628.363636l114.036364 53.527273zM472.436364 397.963636c16.290909 13.963636 23.272727 32.581818 23.272727 55.854546 0 20.945455-9.309091 41.890909-25.6 60.509091-9.309091 9.309091-27.927273 23.272727-53.527273 41.890909-25.6 16.290909-41.890909 32.581818-48.872727 46.545454h128v37.236364h-179.2c0-25.6 9.309091-48.872727 25.6-67.490909 9.309091-11.636364 27.927273-25.6 58.181818-46.545455 16.290909-11.636364 27.927273-20.945455 34.909091-27.927272 11.636364-11.636364 16.290909-25.6 16.290909-39.563637 0-13.963636-4.654545-23.272727-11.636364-30.254545-6.981818-6.981818-18.618182-9.309091-32.581818-9.309091-16.290909 0-27.927273 4.654545-34.909091 16.290909-6.981818 9.309091-11.636364 25.6-13.963636 46.545455h-41.890909c0-27.927273 9.309091-51.2 25.6-69.818182 16.290909-18.618182 39.563636-27.927273 67.490909-27.927273 25.6-9.309091 46.545455 0 62.836364 13.963636zM646.981818 381.672727h39.563637v167.563637h37.236363V581.818182h-37.236363v55.854545h-39.563637V581.818182h-123.345454v-39.563637l123.345454-160.581818z m-2.327273 53.527273l-88.436363 116.363636h90.763636l-2.327273-116.363636z",
    fill: "#1296db",
    "p-id": 7217
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M498.036364 88.436364v95.418181",
    fill: "#1296db",
    "p-id": 7218
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M474.763636 88.436364h46.545455v95.418181h-46.545455z",
    fill: "#1296db",
    "p-id": 7219
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M919.272727 512h-95.418182",
    fill: "#1296db",
    "p-id": 7220
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M823.854545 488.727273h95.418182v46.545454h-95.418182z",
    fill: "#1296db",
    "p-id": 7221
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c2e63d5fafc535c51b0d79c95f3f53c9.svg";
export { ForwardRef as ReactComponent };